import React from 'react'
import PropTypes from 'prop-types'
import { FadeInUpAnimationWrapper } from 'styles/animation'
import ProductCardInfo from './ProductCardInfo'
import { Expand } from '../../Icons'

import {
  ProductCardWrapper,
  ProductCardImage,
  ProductCardInfoWrapper,
  CardModalButton,
} from './ProductCard.style'

const ProductCard = ({
  brand,
  productBrandNameOverride,
  currency,
  description,
  image,
  locale,
  rrpPrice,
  salePrice,
  villagePrice,
  villageLevelLabels,
  onclickProductModal,
  enableImageFadeIn,
}) => (
  <ProductCardWrapper onClick={onclickProductModal}>
    <CardModalButton>
      <Expand width={30} />
    </CardModalButton>
    <>
      {image != null && (
        <FadeInUpAnimationWrapper enabled={enableImageFadeIn}>
          <ProductCardImage
            image={image.portrait.gatsbyImageData}
            alt={image.altText}
          />
        </FadeInUpAnimationWrapper>
      )}
    </>
    <ProductCardInfoWrapper>
      <ProductCardInfo
        {...{
          brand,
          productBrandNameOverride,
          currency,
          description,
          locale,
          rrpPrice,
          salePrice,
          villagePrice,
          labels: villageLevelLabels,
        }}
      />
    </ProductCardInfoWrapper>
  </ProductCardWrapper>
)

ProductCard.propTypes = {
  brand: PropTypes.string.isRequired,
  productBrandNameOverride: PropTypes.string,
  currency: PropTypes.string,
  description: PropTypes.string.isRequired,
  image: PropTypes.oneOfType([PropTypes.object]).isRequired,
  locale: PropTypes.string,
  rrpPrice: PropTypes.number,
  salePrice: PropTypes.number,
  villagePrice: PropTypes.number,
  villageLevelLabels: PropTypes.shape({}),
  onclickProductModal: PropTypes.func,
  enableImageFadeIn: PropTypes.bool,
}

ProductCard.defaultProps = {
  productBrandNameOverride: '',
  locale: 'en',
  salePrice: null,
  currency: null,
  rrpPrice: null,
  villagePrice: null,
  villageLevelLabels: {},
  onclickProductModal: () => {},
  enableImageFadeIn: false,
}

export default ProductCard
